import { getFirestore, doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

/*
Firestore security rules should be set in your Firebase console (not here in code):

service cloud.firestore {
  match /databases/{database}/documents {
    match /mpsEventRegistration/{registrationId} {
      allow read: if true;
      allow update: if request.auth != null && 
                   request.resource.data.paymentStatus == 'paid' &&
                   resource.data.paymentStatus == 'unpaid';
      allow delete: if request.auth != null; // Add appropriate conditions
    }
  }
}
*/

const getMpsApplicationDetails = async (registrationID) => {
    try {
        const docRef = doc(db, "mpsEventRegistration", registrationID);
        const docSnap = await getDoc(docRef);

        let registrationDetails = null;
        if (docSnap.exists()) {
            registrationDetails = docSnap.data();
        } else {
            return { success: false, message: "No such event found" };
        }

        return {
            success: true,
            data: {
                application: registrationDetails,
            },
        };
    } catch (error) {
        console.error("Error retrieving event details and registrations: ", error);
        return { success: false, message: error.message };
    }
};

const withdrawMPSApplication = async (registrationID) => {
    try {
        const docRef = doc(db, "mpsEventRegistration", registrationID);
        
        await updateDoc(docRef, {
            applicationStatus: "Withdrawn",
            updatedAt: serverTimestamp()
        });

        return {
            success: true,
            message: "Application successfully withdrawn.",
        };
    } catch (error) {
        console.error("Error withdrawing application: ", error);
        return {
            success: false,
            message: error.message,
        };
    }
};

export { getMpsApplicationDetails, withdrawMPSApplication };